import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import ConteudoPrincipal from './Sections/conteudo-principal';
import Video from './Sections/video';
import ColegiosParceiros from './Sections/colegios-parceiros';
import Informacoes from './Sections/informacoes'
import { fetchData } from '../../../Api';
import { PageUniexpoColegioInterface } from '../../Services/types';
import Galeria from '../../Components/galeria';

const Colegio: React.FC<any> = ({initialData} : any) => {
    const [colegio, setColegio] = useState<PageUniexpoColegioInterface | null>(initialData?.colegio);
    
    useEffect(() => {
        if (initialData?.colegio) return;
        const loadData = async () => {
            const response = await fetchData("uniexpo-no-seu-colegio");
            if(response){
                if (response.colegio) setColegio(response.colegio);
            }
        };
        
        loadData();
    }, []);
    
    const title = 'Uniexpo no seu colégio';

    const breadcrumb = [{
        name: title,
        slug: 'uniexpo-no-seu-colegio'
    }];

    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} image={colegio ? colegio.imagem : ''} />

                {colegio &&
                    <>
                        <ConteudoPrincipal content={colegio.content} title={colegio.title} buttons={colegio.botoes} />

                        {colegio.depoimentos.length > 0 &&
                            <Informacoes depoimentos={colegio.depoimentos} />
                        }

                        {colegio.galeria.length > 0 &&
                            <Galeria galeria={colegio.galeria} />
                        }

                        {colegio.video &&
                            <Video video={colegio.video} title={colegio.titulo_video} />
                        }

                        {colegio.parceiros &&
                            <ColegiosParceiros parceiros={colegio.parceiros} buttonText={colegio.botaoText} buttonLink={colegio.botaoLink} />
                        }
                    </>
                }
            </ MainLayout>
        </>
    );
};

export default Colegio;
